<style>
</style>
<template>
  <div class="msgRecord-box">
    <p class="title">客户管理&nbsp;&nbsp;<strong>[ 客户列表 ]</strong></p>
    <div class="mb20 order-search-wrap">
      <span>用户名：</span>
      <el-input placeholder="请输入用户名" prefix-icon="el-icon-search" v-model="userName" @keyup.enter.native="search"style="width:200px;" maxlength="50" clearable></el-input>
      <el-button type="primary" class="ml20" @click="search()" >查询</el-button>
      <div class="addBtn">
        <el-button type="primary" style="padding:8px 12px" @click="addCustomer">
          <i class="el-icon-circle-plus"></i>&nbsp;添加客户
        </el-button>
      </div>
    </div>
    <div class="table-wrapper">
      <el-table :data="customerData" border v-loading = "loading" highlight-current-row ref="table" :max-height="tableHeight">
        <el-table-column label="用户名称" prop="userName"></el-table-column>
        <el-table-column label="联系电话" prop="userPhone">
          <template slot-scope="scope">
            {{scope.row.userPhone || '--'}}
          </template>
        </el-table-column>
        <el-table-column label="短信总额" prop="smsTotalSize"></el-table-column>
        <el-table-column label="剩余短信" prop="smsBalanceSize"></el-table-column>
        <el-table-column label="富信总额" prop="smsFuxinTotalSize"></el-table-column>
        <el-table-column label="剩余富信" prop="smsFuxinBalanceSize"></el-table-column>
        <el-table-column label="营销短信总额" prop="smsMarketTotalSize"></el-table-column>
        <el-table-column label="剩余营销短信" prop="smsMarketBalanceSize"></el-table-column>
        <el-table-column label="是否可建子账号" width="120px">
          <template slot-scope="scope">
            <span style="color: #67c23a" v-if="scope.row.childAccount">是</span>
            <span style="color: red"  v-else>否</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="70px">
          <template slot-scope="scope">
            <span style="color: red" v-if="scope.row.userStatus == 2">禁用</span>
            <span style="color: gray" v-else-if="scope.row.userStatus == 1">删除</span>
            <span style="color: #67c23a"  v-else>有效</span>
          </template>
        </el-table-column>
        <el-table-column label="最后登录时间" prop="lastLoginTimeStr"></el-table-column>
        <el-table-column label="创建时间" prop="createtimeStr"></el-table-column>
        <el-table-column label="操作" fixed="right" width="350">
          <template slot-scope="scope">
            <span class="text-blue pointer" @click="recharge(scope.row)" v-if="scope.row.userStatus == 0">充值短信 </span>
            <span class="text-blue pointer" @click="fuxinRecharge(scope.row)" v-if="scope.row.userStatus == 0"> | 充值富信 </span>
             <span class="text-blue pointer" @click="marketRecharge(scope.row)" v-if="scope.row.userStatus == 0"> | 充值营销短信 </span>
            <span v-if="scope.row.userStatus == 0">|</span>
            <span class="pointer" @click="revise(scope.row)" v-if="scope.row.userStatus != 1"> 修改</span>
            <span v-if="scope.row.userName != 'superMan1332' & scope.row.userStatus != 1">
              <span class="text-red pointer" @click="status(scope.row,scope.$index)"> | 状态管理</span>
            </span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="txt-r mtop20">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page="pageNum"
        :page-sizes="[20, 50, 100]"
        :page-size=pageSize
        layout="total, sizes, prev, pager, next, jumper"
        :total=total>
      </el-pagination>
    </div>
    <status v-if="statusShow" @statusClose='closeStatus' :data='statusData'></status>
    <creat v-if="show" @componentClose='close' :data='reviseData'></creat>
    <recharge v-if="rechargeShow" @rechargeClose='rechargeClose' :rechargeData="rechargeData"></recharge>
    <fuxinRecharge v-if="rechargeFuxinShow" @rechargeClose='rechargeFuxinClose' :rechargeData="rechargeData"></fuxinRecharge>
    <marketRecharge v-if="rechargeMarketShow" @rechargeClose='rechargeMarketClose' :rechargeData="rechargeData"></marketRecharge>
  </div>
</template>
<script>
import api from '../../server/api.js'
import creat from '../../components/customer/creatCustomer'
import recharge from '../../components/customer/rechargeMsg'
import fuxinRecharge from '../../components/customer/rechargeFuxinMsg'
import marketRecharge from '../../components/customer/rechargeMarketMsg'
import status from '../../components/customer/status'
export default {
  name: "customerList",
  data(){
    return{
      tableHeight: 100,
      loading:false,
      pageSize: 20,//当前显示条数
      pageNum: 1,//当前页数
      total: 0,//总数
      user: '',//当前登录用户
      isSuperMan: false,//是否是超级用户
      customerData: [],
      show: false,
      reviseData: null,
      rechargeShow: false,
      rechargeFuxinShow: false,
      rechargeMarketShow: false,
      rechargeData: null,
      statusShow: false,
      statusData: null,
      userName: ""
    };
  },
  created(){
    this.getCustomerList();
    this.user = JSON.parse(localStorage.getItem("USER")).userId;
    if(this.user == 1){
      this.user = '';
      this.isSuperMan = true;
    }
  },
  methods: {
    getCustomerList(){//获取客户列表
      let data = {
        "start": this.pageNum,
        "length": this.pageSize,
        "userName": this.userName,
        // "userPhone": 
      }
      this.loading =true;
      let _this = this;
      api.getSysUserList({data:data}).then(res => {
        this.loading =false;
        if(res.status == 'success'){
          _this.tableHeight =
            window.innerHeight - _this.$refs.table.$el.offsetTop - 100;
          _this.total = res.data.count;
          _this.customerData = res.data.resultList;
          res.data.resultList.forEach(function(v,index,arr){
            if(v.userId == _this.user){
              res.data.resultList.splice(index,1);
              _this.total --;
            }
          });
        }
      })
    },
          //搜索
    search(){
      this.startTotal = 1;
     this.getCustomerList();
    },
    addCustomer(){//添加客户
      this.show = true;
      this.reviseData = null;
    },
    close(){//关闭新增
      this.show = false;
      this.getCustomerList();
    },
    revise(row){//修改客户信息prohibit
      this.show = true;
      this.reviseData = row;
    },
    status(row,index,num){
      this.statusShow = true;
      this.statusData = row;
    },
    closeStatus(){
      this.statusShow = false;
      this.getCustomerList();
    },
    recharge(row){//充值短信
      this.rechargeShow = true;
      this.rechargeData = row;
    },
    rechargeClose(){//关闭充值弹窗
      this.rechargeShow = false
      this.getCustomerList();
    },
    fuxinRecharge(row){//充值短信
      this.rechargeFuxinShow = true;
      this.rechargeData = row;
    },
    rechargeFuxinClose(){//关闭充值弹窗
      this.rechargeFuxinShow = false
      this.getCustomerList();
    },
    marketRecharge(row){//充值短信
      this.rechargeMarketShow = true;
      this.rechargeData = row;
    },
    rechargeMarketClose(){//关闭充值弹窗
      this.rechargeMarketShow = false
      this.getCustomerList();
    },
    sizeChange(v){//切换显示条数
      this.pageSize = v;
      this.getCustomerList();
    },
    currentChange(v){//切换页数
      this.pageNum = v;
      this.getCustomerList();
    }
  },
  components: {
    creat,recharge,status,fuxinRecharge,marketRecharge
  }
}
</script>
  




// WEBPACK FOOTER //
// src/view/customer/customerList.vue